import { useCallback } from "react";
import axios from "axios";
import { Urls } from "../../App";

export const useStatusToVerifyService = () => {
  const { baseURL, APIKey } = Urls();
  const URl = baseURL;

  const headers = {
    "Content-Type": "application/json",
    "x-api-key": APIKey,
  };
  const getStatusOfUser = useCallback(
    async (data, accessToken) => {
      try {
        const response = await axios.post(
          `${URl}/api/journey/status`,

          data,
          {
            headers: {
              ...headers,
              Token: `Bearer ${accessToken}`,
            },
          },
        );

        return response.data;
      } catch (error) { }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return { getStatusOfUser };
};
